import { Pipe, PipeTransform, inject } from '@angular/core';
import { HisTranslationService } from '../service/his-translation.service';

@Pipe( {
    name: 'hisTranslate',
    standalone: false
} )
export class HisTranslationPipe implements PipeTransform {
    private hisTranslationService = inject(HisTranslationService);


    /**
     * Translates the attribute from an object to another language if the _foreigntext is correctly filled
     *
     * @param object - the object with translatable attributes
     * @param attributeName - name of the attribute
     * @param language - the language to translate to (if not given the currently selected language from HisBaseGlobalsService is used)
     */
    transform( hisObject: any, hisAttribute: string, language?: string ): string {
        return this.hisTranslationService.translate( hisObject, hisAttribute, language );
    }
}
